import styled from "styled-components"

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export default FlexContainer
